// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
//router
import router from '../common/router'

// vant
import Vant from 'vant';
import 'vant/lib/index.css';
import { Lazyload } from 'vant';
import { Toast } from 'vant';
Vue.use(Lazyload, {
  lazyComponent: true,
});
Toast.setDefaultOptions({ duration: 1000 });
Vue.use(Toast);
Vue.use(Vant);
import VueBarcode from '@xkeshi/vue-barcode';
　Vue.component('barcode', VueBarcode);
function getQueryVariable(variable)
{
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if(pair[0] == variable){return pair[1];}
  }
  return(false);
}
//aixos
import {
    http
} from '../common/http/axios.js'

Vue.prototype.$axios = http

Vue.prototype.$baseImgUrl = 'http://swimming.view.lvseshixian.com';

/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
  document.title = to.meta.title
}
let code = getQueryVariable('code');
  if(code){
      http(
        ' /api/Swimming/login',
        {code:code},
        'post'
        ).then((res) => {
          window.location.href = window.location.origin + window.location.hash
          next();
        }).catch((error) => {
          console.error(`获取失败：${error.message}`);
        });
  }else{
    next();
  }
});
//百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'qFRnT1XTtGPonRRnBDb24xxGndbmaRMM'
})
Vue.prototype.$appid = 'wxeb3768e3b8b71c18'
// 公共样式
import './assets/css/base.css'

//通用js
import commonJs from './assets/js/public.js'
Vue.prototype.$commonJs = commonJs

import App from './App'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  router: router,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js